<template>
  <!-- 一覧表示項目設定タブ -->
  <div id="DisplayItemSetting">
    <div id="container-modal">
      <div class="templateName">表示テンプレート名：{{templateName}}</div>
      <div class="itemSelectionArea">
        <div class="selectionItemArea">
          <div class="labelText">選択可能な項目</div>
          <b-tabs type="is-toggle" expanded id="selectionTable">
            <!-- 標準タブ -->
            <b-tab-item label="標準">
              <b-table
                :data="defaultItemList"
                :checked-rows.sync="selectedItemList"
                narrowed
                :mobile-cards="false"
                class="selectionItems"
              >
                <template slot-scope="props">
                  <td class="checkboxTd">
                    <input 
                      type="checkbox"
                      class="checkbox"
                      @change="selectSelectableItem($event)"
                      :value="props.row"
                      v-model="selectedItemList">
                  </td>
                  <td>{{props.row.itemName}}</td>
                </template>
              </b-table>
            </b-tab-item>
            <!-- 処方箋タブ -->
            <b-tab-item label="処方箋">
              <b-table
                :data="prescriptionItemList"
                :checked-rows.sync="selectedItemList"
                narrowed
                :mobile-cards="false"
                class="selectionItems"
              >
                <template slot-scope="props">
                  <td class="checkboxTd">
                    <input 
                      type="checkbox"
                      class="checkbox"
                      @change="selectSelectableItem($event)"
                      :value="props.row"
                      v-model="selectedItemList">
                  </td>
                  <td>{{props.row.itemName}}</td>
                </template>
              </b-table>
            </b-tab-item>
            <!-- アクセサリータブ -->
            <b-tab-item label="アクセサリー">
              <b-table
                :data="accessoriesItemList"
                :checked-rows.sync="selectedItemList"
                narrowed
                :mobile-cards="false"
                class="selectionItems"
              >
                <template slot-scope="props">
                  <td class="checkboxTd">
                    <input 
                      type="checkbox"
                      class="checkbox"
                      @change="selectSelectableItem($event)"
                      :value="props.row"
                      v-model="selectedItemList">
                  </td>
                  <td>{{props.row.itemName}}</td>
                </template>
              </b-table>
            </b-tab-item>
          </b-tabs>
        </div>
        <!-- 選択された項目 -->
        <div class="selectedItemArea">
          <div class="labelText">選択された項目</div>
          <select id="itemSelectBox" v-model="currentSelectedItem" class="selectBox" size="20" @change="changeControlInactive">
            <option v-for="selectedItem in selectedListWithoutAll" :key="selectedItem.itemId" :value="selectedItem">
              <a>{{selectedItem.itemName}}</a>
            </option>
          </select>
        </div>
        <!-- 表示順 -->
        <div class="buttonArea">
          <fieldset :disabled="isButtonDisabled">
              <div>表示順</div>
              <b-button class="is-primary arrow-button" @click="upDetail">↑</b-button>
              <b-button class="is-primary arrow-button" @click="downDetail">↓</b-button>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { shiftListDetail } from "@/components/mock/guest/patientdashboard/pDashboardUtil";
// このコンポーネントがマウントされる前に使用するのでconst.jsからimportせずここで定義する
const pDashboardFilterCondition = {
    /** 含む */
    include: "0",
    /** 等しい */
    equal: "1"
};
const pDashboardItemKind = {
    /** なし */
    none: 0,
    /** 標準 */
    default: 1,
    /** 処方箋 */
    prescription: 2,
    /** アクセサリー */
    accessory: 3
};
const allItemText = "(すべて)";
const defaultAllObj = {kind: pDashboardItemKind.default, itemId: "defaultAll", itemName: allItemText, displayOrder: 0, dataType: "", width: 0};
const prescriptionAllObj = {kind: pDashboardItemKind.prescription, itemId: "prescriptionAll", itemName: allItemText, displayOrder: 0, dataType: "", width: 0};
const accessoriesAllObj = {kind: pDashboardItemKind.accessory, itemId: "accessoriesAll", itemName: allItemText, displayOrder: 0, dataType: "", width: 0};

export default {
  name: "DisplayItemSetting",
  methods: {
    // 環境設定画面が取得した初期値を受け取る
    setDisplayItemInfo(selectableItemList, displayTemplateInfo) {
      this.selectableItemList = selectableItemList;
      this.displayTemplateSettingList = displayTemplateInfo.settingList;
      this.templateName = displayTemplateInfo.templateName;
      
      // 「表示テンプレートの設定情報」の中に「選択可能な表示項目リスト」の項目がない場合、新しい項目として「表示テンプレートの設定情報」に追加する。
      for (let selectableItem of this.selectableItemList) {
        let isExistItem = this.displayTemplateSettingList.some(setting => setting.itemId == selectableItem.itemId)
        if (!isExistItem) {
          // 項目のデータ型毎にフィルタ条件を設定
          let filterCondition = selectableItem.dataType == "string" ? pDashboardFilterCondition.include : pDashboardFilterCondition.equal;
          this.displayTemplateSettingList.push({
            itemId: selectableItem.itemId,
            itemName: selectableItem.itemName,
            displayFlag: false,
            itemDisplayOrder: 0,
            filterValue1: null,
            filterCondition1: filterCondition,
            filterValue2: null,
            filterCondition2: filterCondition,
            detailDisplayOrder: 0,
            dataType: selectableItem.dataType,
            width: selectableItem.width
          });
        }
      }
      // 「選択可能な表示項目リスト」の中に「表示テンプレートの設定情報」の項目がない場合、削除された項目として「表示テンプレートの設定情報」から削除する。
      for (let setting of this.displayTemplateSettingList) {
        let isExistItem = this.selectableItemList.some(selectableItem => selectableItem.itemId == setting.itemId);
        if (!isExistItem) {
          this.displayTemplateSettingList = this.displayTemplateSettingList.filter(target => {
            return target.itemId != setting.itemId;
          });
        }
      }
      // パラメータの「選択可能な表示項目リスト」をもとに表示項目タブで初期表示する「選択可能な項目リスト」情報を作成する
      this.noneItemList = this.selectableItemList.filter(selectableItem=>{ return selectableItem.kind == pDashboardItemKind.none });
      this.defaultItemList = this.selectableItemList.filter(selectableItem=>{ return selectableItem.kind == pDashboardItemKind.default });
      this.prescriptionItemList = this.selectableItemList.filter(selectableItem=>{ return selectableItem.kind == pDashboardItemKind.prescription });
      this.accessoriesItemList = this.selectableItemList.filter(selectableItem=>{ return selectableItem.kind == pDashboardItemKind.accessory });

      // 各「選択可能な項目」の先頭に"(すべて)"を追加する
      this.defaultItemList.unshift(defaultAllObj);
      this.prescriptionItemList.unshift(prescriptionAllObj);
      this.accessoriesItemList.unshift(accessoriesAllObj);

      // パラメータの表示テンプレートの設定情報をもとに表示項目タブで初期表示する選択された項目リスト情報を作成する
      let settingItemList = this.displayTemplateSettingList.filter(setting => {
        let item = this.selectableItemList.find(selectableItem => selectableItem.itemId == setting.itemId);
        // 項目IDが選択可能な表示項目リストに含まれているかつ、種別が[0:なし]ではないかつ、表示フラグがtrue
        return item && item.kind != pDashboardItemKind.none && setting.displayFlag;
      })

      // 選択された項目リストに追加する
      for (let settingItem of settingItemList) {
        let addSelectedItem = this.selectableItemList.find(selectableItem => selectableItem.itemId == settingItem.itemId);
        this.selectedItemList.push(addSelectedItem);
      }
      // 項目の表示順を1から再設定する
      this.reNumberingDisplayOrder();

      // 選択可能な項目の各種別の"(すべて)"項目のチェックを判定
      this.checkAllItem(pDashboardItemKind.default);
      this.checkAllItem(pDashboardItemKind.prescription);
      this.checkAllItem(pDashboardItemKind.accessory);
    },

    // 表示順ボタンの活性・非活性処理
    changeControlInactive() {
      if (!this.currentSelectedItem) {
        // 項目を未選択の場合、ボタンを非活性にする
        this.isButtonDisabled = true;
      } else {
        // 項目を選択中の場合、ボタンを活性化する
        this.isButtonDisabled = false;
      }
    },
    // 選択中の項目を上の項目と入れ替え
    upDetail() {
      // "(すべて)"を除く選択された項目の中で、最初の項目でないか判定
      if(this.currentSelectedItem != this.selectedListWithoutAll.at(0)) {
        // util内のshiftListDetailに入れ替え対象のリスト、入れ替え対象の項目表示順、上下判定符号(true:上)、入れ替え対象の項目を渡す
        shiftListDetail(this.selectedItemList, this.currentSelectedItem.displayOrder, true, this.currentSelectedItem);
      }
    },
    // 選択中の項目を下の項目と入れ替え
    downDetail() {
      // "(すべて)"を除く選択された項目の中で、最後の項目でないか判定
      if(this.currentSelectedItem != this.selectedListWithoutAll.at(-1)) {
        // util内のshiftListDetailに入れ替え対象のリスト、入れ替え対象の項目表示順、上下判定符号(false:下)、入れ替え対象の項目を渡す
        shiftListDetail(this.selectedItemList, this.currentSelectedItem.displayOrder, false, this.currentSelectedItem);
      }
    },
    // 項目選択時の処理
    selectSelectableItem(event) {
      let isChecked = event.target.checked;   // チェックの有無
      let checkedItem = event.target._value;  // 押下したチェックボックスの項目
      let selectableItemListByKind;           // 種別ごとの選択可能な項目

      // 選択した項目の種別ごとに対象とする選択可能な項目リストを設定する
      if (checkedItem.kind == pDashboardItemKind.default) {
        selectableItemListByKind = this.defaultItemList;
      } else if (checkedItem.kind == pDashboardItemKind.prescription) {
        selectableItemListByKind = this.prescriptionItemList;
      } else if (checkedItem.kind == pDashboardItemKind.accessory) {
        selectableItemListByKind = this.accessoriesItemList;
      }

      // 選択した項目が"(すべて)"の場合
      if (checkedItem.itemName == allItemText) {
        // チェックボックスがONになった場合
        if (isChecked) {
          // 既に選択された項目に存在する項目以外を、選択された項目の末尾に追加する
          let addItems = selectableItemListByKind.filter(selectableItem => {
            return !this.selectedItemList.includes(selectableItem);
          });
          this.selectedItemList = this.selectedItemList.concat(addItems);
        // チェックボックスがOFFになった場合
        } else {
          // 選択された項目から、選択した"(すべて)"と同じ種別の項目を全て削除する
          this.selectedItemList = this.selectedItemList.filter(selectedItem => {
            return selectedItem.kind != checkedItem.kind;
          });
          // 選択中の項目が存在するかつ、選択した"(すべて)"と同じ種別の項目が選択中の場合、
          // 選択中の項目をnullにして、表示順ボタンを非活性にする
          if (this.currentSelectedItem && this.currentSelectedItem.kind == checkedItem.kind) {
            this.currentSelectedItem = null;
            this.changeControlInactive();
          }
        }
      // 選択した項目が"(すべて)"以外の場合
      } else {
        // 選択可能な項目の種別毎の"(すべて)"項目のチェックを判定
        this.checkAllItem(checkedItem.kind);
        // チェックボックスがOFFになったかつ、OFFにした項目が選択された項目で選択されている場合
        if (!isChecked && this.currentSelectedItem == checkedItem) {
          this.currentSelectedItem = null;
          this.changeControlInactive();
        }
      }
      // 変更後の選択された項目の順番で項目表示順を再採番する
      this.reNumberingDisplayOrder();
    },
    // チェックボックスを押下した項目と同じ種別の項目が"(すべて)"以外全て選択されているか判定し、
    // 選択されている場合、同じ種別の"(すべて)"の項目にチェックを入れる
    checkAllItem(selectedItemKind) {
      let selectableItemListByKind;
      let allItemObj;

      // 選択した項目の種別ごとに対象とする項目リストと追加する"(すべて)"項目を設定する
      if (selectedItemKind == pDashboardItemKind.default) {
        selectableItemListByKind = this.defaultItemList;
        allItemObj = defaultAllObj;
      } else if (selectedItemKind == pDashboardItemKind.prescription) {
        selectableItemListByKind = this.prescriptionItemList;
        allItemObj = prescriptionAllObj;
      } else if (selectedItemKind == pDashboardItemKind.accessory)  {
        selectableItemListByKind = this.accessoriesItemList;
        allItemObj = accessoriesAllObj;
      }

      // "(すべて)"以外の項目が全て選択されているか判定する
      let isAll = true;
      for (let selectableItem of selectableItemListByKind) {
        if (selectableItem.itemName != allItemText && !this.selectedItemList.includes(selectableItem)) {
          isAll = false;
          break;
        }
      }

      // "(すべて)"以外の項目が全て選択されているかつ"(すべて)"が未選択の場合
      if (isAll && !this.selectedItemList.includes(allItemObj)) {
        // "(すべて)"の項目にチェックを入れる
        this.selectedItemList.push(allItemObj);
      }

      // "(すべて)"以外の項目に未選択の項目があるかつ"(すべて)"が選択されている場合
      if (!isAll && this.selectedItemList.includes(allItemObj)) {
        // "(すべて)"の項目のチェックを外す
        this.selectedItemList = this.selectedItemList.filter(selectedItem => {
          return selectedItem != allItemObj;
        });
      }
    },
    // 選択された項目の表示順を再採番する
    reNumberingDisplayOrder() {
      let orderCount = 1;
      for (let selectedItem of this.selectedItemList) {
        if (selectedItem.itemName != allItemText) {
          selectedItem.displayOrder = orderCount;
          orderCount++;
        }
      }
    },
    // 環境設定画面のOK押下時に渡す「表示テンプレートの設定情報」を選択された項目をもとに更新する
    updateSettingList() {
      // 表示フラグtrueかつ、種別[0:なし]の項目をカウントする
      let displayNoneItemCount = 0;
      for (let settingItem of this.displayTemplateSettingList) {
        let isExistItem = this.noneItemList.some(noneItem => noneItem.itemId == settingItem.itemId)
        if (settingItem.displayFlag && isExistItem) {
          displayNoneItemCount++;
        }
      }

      // 表示フラグ、表示順を更新する
      for (let settingItem of this.displayTemplateSettingList) {
        let selectableItem = this.selectableItemList.find(selectableItem => selectableItem.itemId == settingItem.itemId);
        let selectedItem = this.selectedItemList.find(selectedItem => selectedItem.itemId == settingItem.itemId);

        // 項目の種別が[0:なし]以外かつ、選択された項目に含まれる場合
        if (selectableItem.kind != pDashboardItemKind.none && selectedItem) {
          // 選択された項目に含まれる項目の場合、表示フラグ:true、表示順を選択された項目の順に設定する
          settingItem.displayFlag = true;
          settingItem.itemDisplayOrder = selectedItem.displayOrder + displayNoneItemCount;  // 種別[0:なし]の項目分、項目表示順を後ろにずらす
        // 項目の種別が[0:なし]以外かつ、選択された項目に含まれない場合
        } else if (selectableItem.kind != pDashboardItemKind.none && !selectedItem) {
          // 選択された項目に含まれない項目の場合、表示フラグ:false、表示順に0を設定する
          settingItem.displayFlag = false;
          settingItem.itemDisplayOrder = 0;
          // 表示しない項目のフィルタ値・フィルタ条件を初期化する
          let filterCondition = selectableItem.dataType == "string" ? pDashboardFilterCondition.include : pDashboardFilterCondition.equal;
          settingItem.filterValue1 = null;
          settingItem.filterCondition1 = filterCondition;
          settingItem.filterValue2 = null;
          settingItem.filterCondition2 = filterCondition;
        }
      }

      // 項目表示順の昇順で並び替え
      this.displayTemplateSettingList.sort((a, b) => {
        let isUp;
        if (a.displayFlag && !b.displayFlag) {
          // 比較元(a)だけ表示する項目の場合は前に移動
          isUp = true;
        } else if (a.displayFlag && b.displayFlag) {
          // 両方表示する項目の場合は項目表示順で並び替え
          isUp = a.itemDisplayOrder < b.itemDisplayOrder
        } else {
          // 比較元(a)が表示しない項目の場合は後に移動
          isUp = false;
        }
        return isUp ? -1 : 1;
      });
    }
  },
  data() {
    return {
      templateName: "",               // 表示テンプレート名
      displayTemplateSettingList: [], // 表示テンプレートの設定情報
      selectableItemList: [],         // 選択可能な表示項目リスト
      noneItemList: [],               // 選択可能な項目リスト_なし
      defaultItemList: [],            // 選択可能な項目リスト_標準
      prescriptionItemList: [],       // 選択可能な項目リスト_処方箋
      accessoriesItemList: [],        // 選択可能な項目リスト_アクセサリー
      selectedItemList: [],           // 選択された項目リスト
      isButtonDisabled: true,         // 表示順ボタンの活性/非活性
      currentSelectedItem: null,      // 選択された項目の中から現在選択中の項目
    }
  },
  computed: {
    // "(すべて)"の項目を除いた選択された項目リストを返す
    selectedListWithoutAll() {
      return this.selectedItemList.filter(selectedItem => {
        return selectedItem.itemName != allItemText;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
$boxHeight: 540px;
#DisplayItemSetting {
  width: auto;
  height: auto;
}
.itemSelectionArea {
  display: grid;
  grid-template-columns: 4.5fr 4.5fr 1.0fr;
}
#DisplayItemSetting #container-modal .templateName {
  margin-bottom: 4px;
  text-align: left;
}
#DisplayItemSetting #container-modal .labelText {
  text-align: left;
}
.itemSelectionArea .selectedItemArea {
  margin-left: 40px;
}
.itemSelectionArea .buttonArea {
  vertical-align: middle;
  margin: 0 auto;
  text-align: center;
}
.itemSelectionArea .buttonArea .is-primary {
  display: flex;
  margin: 5px 0 5px 0;
}
.arrow-button {
  width: 50px;
  height: 25px;
  font-size: 16px;
  margin-top: 0 !important;
}
#selectionTable {
  border: solid 1px #767676;
  height: $boxHeight;
}
select.selectBox {
  vertical-align: middle;
  height: $boxHeight;
}
select.selectBox option:checked {
  background: linear-gradient(#061e57, #061e57);
  color: #ffffff;
}
.selectionItems {
  overflow: auto;
  overflow-x: hidden;
  height: 468px;
}
.checkboxTd {
  width: 40px;
}
.checkbox {
  vertical-align: middle;
  accent-color: #061e57;
  inline-size: 1.2rem;
  block-size: 1.2rem;
}
</style>
<style lang="scss">
#selectionTable nav {
  overflow-x: hidden;
}
#selectionTable nav ul li a {
  border-radius: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/patientdashboard/DisplayItemSetting.vue